function App(window, document) {

    this.Globals = require('./config/cached-elements');

    this.Globals.$document.on('ready', function () {

        //  Priority Load

        require('./components/foundation').init();

        //  Individual components

        require('./components/accordion').init();
        require('./components/cookie-notice').init();
        require('./components/filter').init();
        require('./components/form').init();
        require('./components/google-map').init();
        require('./components/grid').init();
        require('./components/menu-solutions').init();
        require('./components/price-item').init();
        require('./components/scroller').init();
        require('./components/slider').init();
        require('./components/trigger').init();
        require('./components/video').init();
        require('./components/waypoints').init();

    });

}

window.App = new App(this, document);
